import { xcss } from '@atlaskit/primitives';
import { CrossflowCtaPrimaryPressable } from '@post-office/components--crossflow-cta-button';
import { type FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { type App } from '../../types';
import { getCrossflowOptionsForConfluenceHomeBanner } from '../../util/cross-flow-options';

const buttonText = (
	<FormattedMessage
		id="post-office.confluence-banner-first-party-recommendation.try-it-now"
		defaultMessage="Try it now"
		description={`CTA button text for the Confluence banner first party recommendation`}
	/>
);

const ctaButtonStyles = xcss({
	minWidth: '100px',
	color: 'color.link',
	marginRight: 'space.100',
	backgroundColor: 'color.background.accent.blue.subtlest',
	paddingInline: 'space.150',
	paddingBlock: 'space.100',
	fontWeight: 'font.weight.medium',
	borderRadius: 'radius.small',
	fontSize: '14px',
	':hover': {
		backgroundColor: 'color.background.accent.blue.subtler',
	},
});

export const CTAButton: FunctionComponent<{ app: App }> = ({ app }) => {
	return (
		<CrossflowCtaPrimaryPressable
			crossflowOptions={getCrossflowOptionsForConfluenceHomeBanner({
				app,
				sourceContext: 'tryItNow',
			})}
			ctaText={buttonText}
			pressableStyle={ctaButtonStyles}
		/>
	);
};
